// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
// import get from 'lodash/get';
// import adsConfig from '../../../config/ads';
// import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  // const { store } = action;
  const typeMap = {
    INNOVATION_BY_DESIGN_APPLY_LOADING() {
      return {
        isLoading: true,
        innovationByDesignApply: action.innovationByDesignApply,
        allRendered: false
      };
    },
    INNOVATION_BY_DESIGN_APPLY_LOADED() {
      return {
        isLoading: false,
        data: action.innovationByDesignApply,
        allRendered: false
      };
    },
    INNOVATION_BY_DESIGN_APPLY_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesignApply.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
